export const HYDRATE_CART = /* GraphQL */ `
  mutation hydrateCart($input: CartInput!) {
    hydrate(input: $input) {
      ...cartFields
    }
  }
`;
export const SET_CUSTOMER = /* GraphQL */ `
  mutation setCustomer($cartId: UUID!, $input: CustomerInput!) {
    setCustomer(id: $cartId, input: $input) {
      ...cartFields
    }
  }
`;
export const SET_META = /* GraphQL */ `
  mutation setMeta($cartId: UUID!, $meta: [KeyValueInput]!, $merge: Boolean) {
    setMeta(id: $cartId, meta: $meta, merge: $merge) {
      ...cartFields
    }
  }
`;
export const ADD_SKU_ITEM = /* GraphQL */ `
  mutation addSkuItem($cartId: UUID!, $input: CartSkuItemInput!) {
    addSkuItem(id: $cartId, input: $input) {
      ...cartFields
    }
  }
`;
export const REMOVE_CART_ITEM = /* GraphQL */ `
  mutation removeCartItem(
    $cartId: UUID!
    $sku: String!
    $quantity: PositiveInt
  ) {
    removeCartItem(id: $cartId, sku: $sku, quantity: $quantity) {
      ...cartFields
    }
  }
`;
export const ADD_CART_ITEM = /* GraphQL */ `
  mutation addCartItem($cartId: UUID!, $sku: String!, $quantity: PositiveInt!) {
    addCartItem(id: $cartId, sku: $sku, quantity: $quantity) {
      ...cartFields
    }
  }
`;
export const PLACE_CART = /* GraphQL */ `
  mutation placeCart($cartId: UUID!) {
    place(id: $cartId) {
      ...cartFields
    }
  }
`;
export const FULFILL_CART = /* GraphQL */ `
  mutation fulfillCart($cartId: UUID!, $orderId: String!) {
    fulfill(id: $cartId, orderId: $orderId) {
      ...cartFields
    }
  }
`;
export const CHANGE_CART_ITEM_PRICING = /* GraphQL */ `
  mutation changeCartItemPricing(
    $cartId: UUID!
    $input: CartItemPricingChangeType!
  ) {
    changeCartItemPricing(id: $cartId, input: $input) {
      ...cartFields
    }
  }
`;
